import { render, staticRenderFns } from "./indexQuestions.vue?vue&type=template&id=7e620b92&scoped=true&"
import script from "./indexQuestions.vue?vue&type=script&lang=js&"
export * from "./indexQuestions.vue?vue&type=script&lang=js&"
import style0 from "./indexQuestions.vue?vue&type=style&index=0&id=7e620b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e620b92",
  null
  
)

export default component.exports